"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LiveReviewWidget = _interopRequireWildcard(require("@common/components/chat/LiveReviewWidget"));
var _liveReviewOoxml = require("@common/utils/liveReviewOoxml");
var _applyOutcome = require("@common/utils/applyOutcome");
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _liveReview = require("@common/schemas/live-review");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _AuthContext = require("../../context/AuthContext");
var _ChatContext = require("../../context/ChatContext");
var _WordDocumentContext = require("../../context/WordDocumentContext");
var _api = require("../../utils/api");
var _actionOutcomeSave = require("../../utils/action-outcome-save");
var _liveReviewApply = require("../../utils/live-review-apply");
var _DocumentPageContext = require("../../context/DocumentPageContext");
var _useProposalEngineEnabled = require("../../hooks/use-proposal-engine-enabled");
var _cardTargetState = require("./proposal-card/card-target-state");
var _commentTargetRecovery = require("./proposal-card/comment-target-recovery");
var _useReportGeneratedRedlines = require("../../hooks/use-report-generated-redlines");
var _BulkApplyRunContext = require("../../context/BulkApplyRunContext");
var _LiveReviewRemedyPreview = _interopRequireDefault(require("./LiveReviewRemedyPreview"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LIVE_REVIEW_STATUS_POLL_INTERVAL_MS = 10000;
function everyEligibleRuleWasBulkApplied(snapshot, isActionApplied, commentHeldBackReason) {
  var reviewId = snapshot.reviewId;
  if (!reviewId || !isActionApplied((0, _liveReviewOoxml.buildBulkApplyId)(reviewId))) return false;
  return (0, _LiveReviewWidget.getBulkApplyRuleUuids)((0, _liveReview.getVisibleLiveReviewIssues)(snapshot), commentHeldBackReason).every(function (ruleUuid) {
    return isActionApplied((0, _liveReviewOoxml.buildBulkApplyRuleId)(reviewId, ruleUuid));
  });
}
function arePropsEqual(prev, next) {
  if (prev.conversationId !== next.conversationId) return false;
  if (prev.messageId !== next.messageId) return false;
  if (prev.data.status !== next.data.status) return false;
  if (prev.data.issues.length !== next.data.issues.length) return false;
  for (var i = 0; i < prev.data.issues.length; i++) {
    var _a$remedies, _b$remedies, _a$comments, _b$comments;
    var a = prev.data.issues[i];
    var b = next.data.issues[i];
    if (a.ruleUuid !== b.ruleUuid) return false;
    if (a.stage !== b.stage) return false;
    if (a.match !== b.match) return false;
    if (a.responded !== b.responded) return false;
    if (a.conceded !== b.conceded) return false;
    var aRemedies = (_a$remedies = a.remedies) !== null && _a$remedies !== void 0 ? _a$remedies : [];
    var bRemedies = (_b$remedies = b.remedies) !== null && _b$remedies !== void 0 ? _b$remedies : [];
    if (aRemedies.length !== bRemedies.length) return false;
    for (var j = 0; j < aRemedies.length; j++) {
      if (aRemedies[j].id !== bRemedies[j].id) return false;
    }
    var aComments = (_a$comments = a.comments) !== null && _a$comments !== void 0 ? _a$comments : [];
    var bComments = (_b$comments = b.comments) !== null && _b$comments !== void 0 ? _b$comments : [];
    if (aComments.length !== bComments.length) return false;
    for (var _j = 0; _j < aComments.length; _j++) {
      if (aComments[_j].id !== bComments[_j].id) return false;
    }
  }
  return true;
}
function LiveReviewWidget(_ref) {
  var _snapshot$reviewId;
  var data = _ref.data,
    conversationId = _ref.conversationId,
    messageId = _ref.messageId;
  var actionScope = (messageId === null || messageId === void 0 ? void 0 : messageId.trim()) || data.reviewId;
  var _useChat = (0, _ChatContext.useChat)(),
    isActionApplied = _useChat.isActionApplied,
    isActionDismissed = _useChat.isActionDismissed,
    isActionDismissalSaving = _useChat.isActionDismissalSaving,
    markActionAsApplied = _useChat.markActionAsApplied,
    recordActionFailure = _useChat.recordActionFailure,
    markActionAsFailed = _useChat.markActionAsFailed,
    getActionFailure = _useChat.getActionFailure,
    markActionAsSuperseded = _useChat.markActionAsSuperseded,
    getActionSupersession = _useChat.getActionSupersession,
    markActionAsUnapplied = _useChat.markActionAsUnapplied,
    markActionAsDismissed = _useChat.markActionAsDismissed,
    markActionAsUndismissed = _useChat.markActionAsUndismissed;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    selectBookmarksRange = _useWordDocument.selectBookmarksRange;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    resolvedAuthorName = _useAuthInfo.authorName;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var authorName = resolvedAuthorName !== null && resolvedAuthorName !== void 0 ? resolvedAuthorName : undefined;
  var bulkApplyRun = (0, _BulkApplyRunContext.useBulkApplyRun)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    polledData = _useState2[0],
    setPolledData = _useState2[1];
  var authHeaderRef = (0, _react.useRef)(authHeader);
  authHeaderRef.current = authHeader;
  var snapshot = polledData && polledData.generatedAt >= data.generatedAt ? polledData : data;
  var snapshotRef = (0, _react.useRef)(snapshot);
  snapshotRef.current = snapshot;
  (0, _react.useEffect)(function () {
    var reviewId = data.reviewId;
    if (!reviewId || snapshot.status !== "running") return;
    var cancelled = false;
    var interval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var fresh;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (authHeaderRef.current) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.n = 2;
            return (0, _api.fetchLiveReviewSnapshot)(authHeaderRef.current, reviewId);
          case 2:
            fresh = _context.v;
            if (!cancelled && fresh) setPolledData(fresh);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    })), LIVE_REVIEW_STATUS_POLL_INTERVAL_MS);
    return function () {
      cancelled = true;
      clearInterval(interval);
    };
  }, [data.reviewId, snapshot.status]);
  var liveReviewRedlineIds = (0, _react.useMemo)(function () {
    return (0, _useReportGeneratedRedlines.listLiveReviewRedlineIds)({
      snapshot: snapshot,
      messageId: messageId
    });
  }, [snapshot, messageId]);
  (0, _useReportGeneratedRedlines.useReportGeneratedRedlines)({
    initiatedFrom: "live_review",
    reviewId: (_snapshot$reviewId = snapshot.reviewId) !== null && _snapshot$reviewId !== void 0 ? _snapshot$reviewId : null,
    redlineIds: liveReviewRedlineIds
  });
  var proposalEngineEnabled = (0, _useProposalEngineEnabled.useProposalEngineEnabled)();
  var issueCommentTargets = (0, _react.useMemo)(function () {
    return !proposalEngineEnabled ? [] : (0, _liveReview.getVisibleLiveReviewIssues)(snapshot).flatMap(function (issue) {
      var _issue$comments;
      return ((_issue$comments = issue.comments) !== null && _issue$comments !== void 0 ? _issue$comments : []).map(function (issueComment) {
        return (0, _commentTargetRecovery.commentContentOfIssueComment)(issueComment, (0, _commentTargetRecovery.issueCommentBookmarksOf)(issueComment, issue.detectionBookmarks));
      });
    });
  }, [snapshot, proposalEngineEnabled]);
  var watchedPage = (0, _DocumentPageContext.useWatchedDocumentPageIfAny)(issueCommentTargets.flatMap(function (issueCommentTarget) {
    return issueCommentTarget.bookmarks;
  }));
  var commentTargetRecoveriesVersion = (0, _react.useSyncExternalStore)(_commentTargetRecovery.commentTargetRecoveries.subscribe, _commentTargetRecovery.commentTargetRecoveries.version);
  (0, _react.useEffect)(function () {
    if (watchedPage === null) return;
    var _iterator = _createForOfIteratorHelper(issueCommentTargets),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var issueCommentTarget = _step.value;
        _commentTargetRecovery.commentTargetRecoveries.followTarget(issueCommentTarget, (0, _commentTargetRecovery.commentParagraphReadsGone)(issueCommentTarget.bookmarks, watchedPage));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [issueCommentTargets, watchedPage]);
  var commentHeldBackReason = (0, _react.useCallback)(function (issue, issueComment) {
    var _commentTargetStateOf, _commentTargetStateOf2;
    if (!proposalEngineEnabled || watchedPage === null) return null;
    var commentBookmarks = (0, _commentTargetRecovery.issueCommentBookmarksOf)(issueComment, issue.detectionBookmarks);
    return (_commentTargetStateOf = (_commentTargetStateOf2 = (0, _cardTargetState.commentTargetStateOf)(commentBookmarks, watchedPage, _commentTargetRecovery.commentTargetRecoveries.recoveryFoundNothing(commentBookmarks))) === null || _commentTargetStateOf2 === void 0 ? void 0 : _commentTargetStateOf2.heldBackReason) !== null && _commentTargetStateOf !== void 0 ? _commentTargetStateOf : null;
  }, [proposalEngineEnabled, watchedPage, commentTargetRecoveriesVersion]);
  var getActionSupersessionRef = (0, _react.useRef)(getActionSupersession);
  getActionSupersessionRef.current = getActionSupersession;
  var remedySupersessionSignature = JSON.stringify((0, _liveReview.getVisibleLiveReviewIssues)(snapshot).flatMap(function (issue) {
    var _issue$remedies;
    return ((_issue$remedies = issue.remedies) !== null && _issue$remedies !== void 0 ? _issue$remedies : []).map(function (remedy) {
      var _getActionSupersessio;
      var remedyActionId = (0, _liveReviewOoxml.buildActionId)(actionScope, (0, _liveReviewOoxml.liveReviewIssueKey)(issue), "remedy", remedy.id);
      return [remedyActionId, (_getActionSupersessio = getActionSupersession(conversationId, remedyActionId)) !== null && _getActionSupersessio !== void 0 ? _getActionSupersessio : null];
    });
  }));
  var partlyAppliedReasonOf = function partlyAppliedReasonOf(failureConversationId, actionId) {
    var failure = getActionFailure(failureConversationId, actionId);
    return failure !== null && failure !== void 0 && failure.isPartiallyApplied ? failure.reason : null;
  };
  var partlyAppliedReasonOfRef = (0, _react.useRef)(partlyAppliedReasonOf);
  partlyAppliedReasonOfRef.current = partlyAppliedReasonOf;
  var remedyPartlyAppliedSignature = JSON.stringify((0, _liveReview.getVisibleLiveReviewIssues)(snapshot).flatMap(function (issue) {
    var _issue$remedies2;
    return ((_issue$remedies2 = issue.remedies) !== null && _issue$remedies2 !== void 0 ? _issue$remedies2 : []).map(function (remedy) {
      return partlyAppliedReasonOf(conversationId, (0, _liveReviewOoxml.buildActionId)(actionScope, (0, _liveReviewOoxml.liveReviewIssueKey)(issue), "remedy", remedy.id));
    });
  }));
  var commentFailureReasonOf = function commentFailureReasonOf(failureConversationId, actionId) {
    if (!proposalEngineEnabled) return null;
    var failure = getActionFailure(failureConversationId, actionId);
    return failure === undefined || failure.isPartiallyApplied ? null : failure.reason;
  };
  var commentFailureReasonOfRef = (0, _react.useRef)(commentFailureReasonOf);
  commentFailureReasonOfRef.current = commentFailureReasonOf;
  var commentFailureSignature = JSON.stringify((0, _liveReview.getVisibleLiveReviewIssues)(snapshot).flatMap(function (issue) {
    var _issue$comments2;
    return ((_issue$comments2 = issue.comments) !== null && _issue$comments2 !== void 0 ? _issue$comments2 : []).map(function (issueComment) {
      return commentFailureReasonOf(conversationId, (0, _liveReviewOoxml.buildActionId)(actionScope, (0, _liveReviewOoxml.liveReviewIssueKey)(issue), "comment", issueComment.id));
    });
  }));
  var interactions = (0, _react.useMemo)(function () {
    return {
      isActionApplied: isActionApplied,
      isActionDismissed: isActionDismissed,
      isActionDismissalSaving: isActionDismissalSaving,
      markActionAsApplied: markActionAsApplied,
      markActionAsFailed: recordActionFailure,
      markActionAsPartlyApplied: function markActionAsPartlyApplied(failureConversationId, actionId, reason, partlyAppliedMessage) {
        recordActionFailure(failureConversationId, actionId, reason);
        markActionAsFailed(failureConversationId, actionId, {
          reason: partlyAppliedMessage,
          isPartiallyApplied: true,
          conflictingActionIds: []
        });
      },
      getActionSupersession: function getActionSupersession(supersessionConversationId, actionId) {
        return getActionSupersessionRef.current(supersessionConversationId, actionId);
      },
      partlyAppliedReasonOf: function partlyAppliedReasonOf(failureConversationId, actionId) {
        return partlyAppliedReasonOfRef.current(failureConversationId, actionId);
      },
      markActionAsUnapplied: markActionAsUnapplied,
      markActionAsDismissed: markActionAsDismissed,
      markActionAsUndismissed: markActionAsUndismissed,
      applyRemedy: function () {
        var _applyRemedy2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(issue, remedy) {
          var _snapshot$reviewId2, _snapshot$reviewId3;
          var hydrated;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return (0, _liveReviewApply.hydrateRemedyOoxml)(remedy, issue.ruleUuid, {
                  authHeader: authHeader,
                  reviewId: (_snapshot$reviewId2 = snapshot.reviewId) !== null && _snapshot$reviewId2 !== void 0 ? _snapshot$reviewId2 : null
                });
              case 1:
                hydrated = _context2.v;
                _context2.n = 2;
                return (0, _liveReviewApply.applyRemedy)({
                  remedy: hydrated,
                  reviewId: (_snapshot$reviewId3 = snapshot.reviewId) !== null && _snapshot$reviewId3 !== void 0 ? _snapshot$reviewId3 : null,
                  author: authorName
                });
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        function applyRemedy(_x, _x2) {
          return _applyRemedy2.apply(this, arguments);
        }
        return applyRemedy;
      }(),
      applyComment: function () {
        var _applyComment2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(issue, comment) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _context3.n = 1;
                return (0, _liveReviewApply.applyComment)(comment, issue.detectionBookmarks);
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        function applyComment(_x3, _x4) {
          return _applyComment2.apply(this, arguments);
        }
        return applyComment;
      }(),
      commentHeldBackReason: commentHeldBackReason,
      commentFailureReasonOf: function commentFailureReasonOf(failureConversationId, actionId) {
        return commentFailureReasonOfRef.current(failureConversationId, actionId);
      },
      renderRemedyPreview: function renderRemedyPreview(issue, remedy, flags) {
        var _snapshot$reviewId4;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveReviewRemedyPreview.default, {
          issue: issue,
          remedy: remedy,
          reviewId: (_snapshot$reviewId4 = snapshot.reviewId) !== null && _snapshot$reviewId4 !== void 0 ? _snapshot$reviewId4 : null,
          authHeader: authHeader,
          authorName: authorName,
          hidden: flags.dismissed,
          applied: flags.applied
        });
      },
      goToBookmarks: function () {
        var _goToBookmarks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(bookmarks) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return selectBookmarksRange(bookmarks);
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        function goToBookmarks(_x5) {
          return _goToBookmarks.apply(this, arguments);
        }
        return goToBookmarks;
      }(),
      onApplyAll: function onApplyAll(eligibleRuleUuids) {
        if (!authHeader || !snapshot.reviewId) return;
        var reviewId = snapshot.reviewId;
        var ruleUuids = eligibleRuleUuids.filter(function (ruleUuid) {
          return !isActionApplied(conversationId, (0, _liveReviewOoxml.buildBulkApplyRuleId)(reviewId, ruleUuid));
        });
        if (ruleUuids.length === 0) return;
        var visibleIssues = (0, _liveReview.getVisibleLiveReviewIssues)(snapshotRef.current);
        var nameByUuid = new Map(visibleIssues.map(function (issue) {
          return [issue.ruleUuid, issue.name];
        }));
        var issuesWithoutSupersededRemedies = visibleIssues.map(function (issue) {
          var _issue$remedies3;
          return _objectSpread(_objectSpread({}, issue), {}, {
            remedies: ((_issue$remedies3 = issue.remedies) !== null && _issue$remedies3 !== void 0 ? _issue$remedies3 : []).filter(function (remedy) {
              return !getActionSupersessionRef.current(conversationId, (0, _liveReviewOoxml.buildActionId)(actionScope, (0, _liveReviewOoxml.liveReviewIssueKey)(issue), "remedy", remedy.id));
            })
          });
        });
        bulkApplyRun.startRun({
          initiatedFrom: "live_review",
          reviewId: reviewId,
          rules: ruleUuids.map(function (ruleId) {
            return {
              ruleId: ruleId,
              ruleName: nameByUuid.get(ruleId)
            };
          }),
          source: (0, _liveReviewApply.reviewBulkApplySource)(authHeader, reviewId, issuesWithoutSupersededRemedies, ruleUuids),
          onComplete: function onComplete(outcome) {
            return settleBulkActionOutcomes(outcome, ruleUuids, issuesWithoutSupersededRemedies);
          }
        });
      },
      isApplyingAll: bulkApplyRun.isRunning,
      hasAppliedAll: everyEligibleRuleWasBulkApplied(snapshot, function (actionId) {
        return isActionApplied(conversationId, actionId);
      }, commentHeldBackReason),
      onError: function onError(error, context) {
        return sendError === null || sendError === void 0 ? void 0 : sendError(error, context);
      },
      notifySaveFailure: _actionOutcomeSave.toastActionOutcomeSaveFailure
    };
  }, [actionScope, authHeader, authorName, conversationId, snapshot, isActionApplied, isActionDismissed, isActionDismissalSaving, remedySupersessionSignature, remedyPartlyAppliedSignature, commentFailureSignature, bulkApplyRun, markActionAsApplied, markActionAsDismissed, markActionAsFailed, markActionAsUnapplied, markActionAsUndismissed, recordActionFailure, messageId, selectBookmarksRange, sendError, commentHeldBackReason]);
  var settleBulkActionOutcomes = function settleBulkActionOutcomes(outcome, sentRuleUuids, sentIssues) {
    var succeeded = new Set(outcome.creditedRuleIds);
    var failedRuleIds = new Set(outcome.failedRules.map(function (rule) {
      return rule.ruleId;
    }));
    var settledByRun = new Set([].concat(_toConsumableArray(succeeded), _toConsumableArray(outcome.notChosenRuleIds.filter(function (ruleUuid) {
      return !failedRuleIds.has(ruleUuid);
    }))));
    var currentSnapshot = snapshotRef.current;
    var reviewId = currentSnapshot.reviewId;
    if (reviewId) {
      settledByRun.forEach(function (ruleUuid) {
        return markActionAsApplied(conversationId, (0, _liveReviewOoxml.buildBulkApplyRuleId)(reviewId, ruleUuid));
      });
      var everySentRuleSettled = sentRuleUuids.every(function (ruleUuid) {
        return settledByRun.has(ruleUuid);
      });
      if (everySentRuleSettled) markActionAsApplied(conversationId, (0, _liveReviewOoxml.buildBulkApplyId)(reviewId));
    }
    var remedyApplied = outcome.runKind === "local" ? new Set(outcome.redlineAppliedRuleIds) : succeeded;
    var commentApplied = outcome.runKind === "local" ? new Set(outcome.commentAppliedRuleIds) : succeeded;
    var notChosen = new Set(outcome.notChosenRuleIds);
    var commentOutcomesOfLocalRun = outcome.runKind === "local" ? outcome.commentOutcomes : [];
    var commentOutcomeOf = function commentOutcomeOf(ruleUuid, issueComment) {
      var _commentOutcomesOfLoc;
      return (_commentOutcomesOfLoc = commentOutcomesOfLocalRun.find(function (commentOutcome) {
        return commentOutcome.ruleId === ruleUuid && commentOutcome.issueCommentId === issueComment.id;
      })) !== null && _commentOutcomesOfLoc !== void 0 ? _commentOutcomesOfLoc : null;
    };
    var ruleHeldBackACommentItCannotName = function ruleHeldBackACommentItCannotName(ruleUuid) {
      return commentOutcomesOfLocalRun.some(function (commentOutcome) {
        return commentOutcome.ruleId === ruleUuid && commentOutcome.issueCommentId === null && commentOutcome.result === "heldBack";
      });
    };
    var partlyAppliedCardByRuleUuid = new Map(outcome.partiallyAppliedCards.map(function (card) {
      return [card.ruleId, card];
    }));
    var sentRules = new Set(sentRuleUuids);
    var sentIssueRuleUuids = new Set();
    var notChosenRemedyActionIdsByRuleUuid = new Map();
    var attempted = [];
    var applied = new Set();
    var partlyAppliedRemedies = [];
    var failureReasonByActionId = new Map();
    var _iterator2 = _createForOfIteratorHelper(sentIssues),
      _step2;
    try {
      var _loop = function _loop() {
        var _issue$remedies4, _issue$comments3;
        var issue = _step2.value;
        if (!issue.ruleUuid || !sentRules.has(issue.ruleUuid)) return 1; // continue
        var ruleUuid = issue.ruleUuid;
        var remedyActionIds = ((_issue$remedies4 = issue.remedies) !== null && _issue$remedies4 !== void 0 ? _issue$remedies4 : []).map(function (remedy) {
          return (0, _liveReviewOoxml.buildActionId)(actionScope, ruleUuid, "remedy", remedy.id);
        });
        sentIssueRuleUuids.add(ruleUuid);
        if (notChosen.has(ruleUuid)) notChosenRemedyActionIdsByRuleUuid.set(ruleUuid, remedyActionIds);else attempted.push.apply(attempted, _toConsumableArray(remedyActionIds));
        var partlyAppliedCard = partlyAppliedCardByRuleUuid.get(ruleUuid);
        if (partlyAppliedCard !== undefined) {
          remedyActionIds.forEach(function (id) {
            return partlyAppliedRemedies.push({
              actionId: id,
              reason: partlyAppliedCard.reason
            });
          });
          if (partlyAppliedCard.everyWriteLanded) remedyActionIds.forEach(function (id) {
            return applied.add(id);
          });
        } else if (remedyApplied.has(ruleUuid)) {
          remedyActionIds.forEach(function (id) {
            return applied.add(id);
          });
        }
        var _iterator4 = _createForOfIteratorHelper((_issue$comments3 = issue.comments) !== null && _issue$comments3 !== void 0 ? _issue$comments3 : []),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var comment = _step4.value;
            var commentOutcome = commentOutcomeOf(ruleUuid, comment);
            if ((commentOutcome === null || commentOutcome === void 0 ? void 0 : commentOutcome.result) === "heldBack" || commentOutcome === null && ruleHeldBackACommentItCannotName(ruleUuid)) continue;
            var commentActionId = (0, _liveReviewOoxml.buildActionId)(actionScope, ruleUuid, "comment", comment.id);
            attempted.push(commentActionId);
            if (commentOutcome !== null && commentOutcome !== void 0 && commentOutcome.failureReason) failureReasonByActionId.set(commentActionId, commentOutcome.failureReason);
            if ((commentOutcome === null || commentOutcome === void 0 ? void 0 : commentOutcome.result) === "failed" && commentOutcome.failureMessage !== null) {
              markActionAsFailed(conversationId, commentActionId, {
                reason: commentOutcome.failureMessage,
                isPartiallyApplied: false,
                conflictingActionIds: []
              });
            }
            if (commentOutcome === null ? commentApplied.has(ruleUuid) : commentOutcome.result === "written") applied.add(commentActionId);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    (0, _applyOutcome.recordBulkApplyOutcomes)(attempted, applied, {
      markApplied: function markApplied(actionId) {
        return markActionAsApplied(conversationId, actionId);
      },
      markFailed: function markFailed(actionId, reason) {
        return recordActionFailure(conversationId, actionId, reason);
      }
    }, failureReasonByActionId);
    partlyAppliedRemedies.forEach(function (_ref3) {
      var actionId = _ref3.actionId,
        reason = _ref3.reason;
      return markActionAsFailed(conversationId, actionId, {
        reason: reason,
        isPartiallyApplied: true,
        conflictingActionIds: []
      });
    });
    var _iterator3 = _createForOfIteratorHelper(outcome.notChosenCards),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _notChosenRemedyActio;
        var card = _step3.value;
        var winningRuleUuid = card.conflictingRuleIds.find(function (ruleUuid) {
          return sentIssueRuleUuids.has(ruleUuid);
        });
        var supersededBy = winningRuleUuid !== null && winningRuleUuid !== void 0 ? winningRuleUuid : _RemedyActionPrimitives.DOCUMENT_WORDS_SUPERSESSION;
        var _iterator5 = _createForOfIteratorHelper((_notChosenRemedyActio = notChosenRemedyActionIdsByRuleUuid.get(card.ruleId)) !== null && _notChosenRemedyActio !== void 0 ? _notChosenRemedyActio : []),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var remedyActionId = _step5.value;
            markActionAsSuperseded(conversationId, remedyActionId, supersededBy);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveReviewWidget.default, {
      data: snapshot,
      conversationId: conversationId,
      messageId: actionScope,
      interactions: interactions,
      "data-sentry-element": "SharedLiveReviewWidget",
      "data-sentry-source-file": "LiveReviewWidget.tsx"
    })
  });
}
var _default = exports.default = /*#__PURE__*/_react.default.memo(LiveReviewWidget, arePropsEqual);